module.exports = function() {
  return new Worker(__webpack_public_path__ + "46bb3afbd1ae3441dfc0.worker.js");
};